import { OptionalStateCarts, StateCartEntry } from '@spa/lib/store/carts/CartsState';
import { createSelector } from '@reduxjs/toolkit';
import selectCarts from '@spa/lib/store/carts/selectors/selectCarts';

const selectEmployeeDiscountBlockingEntries = createSelector(
  [selectCarts],
  (carts: OptionalStateCarts): ReadonlyArray<StateCartEntry> => {
    return Object.values(carts).flatMap((cart) =>
      (cart?.entries ?? []).filter(({ hasProductDiscount }) => hasProductDiscount === true)
    );
  }
);

export default selectEmployeeDiscountBlockingEntries;
